import { CustomRoute } from "@/interfaces";
import { LogIn } from "lucide-react";
import React from "react";
import { Navigate } from "react-router";

const LoginPage = React.lazy(() => import("../modules/Auth/Login"));
const CognitoCallback = React.lazy(() => import("../modules/Auth/CognitoCallback"));

/**
 * Public routes for logged-out users
 * Includes login, password reset, and public pages
 */
const guestRoutes: CustomRoute[] = [
  {
    path: "/",
    id: "Public",
    element: <LoginPage />,
    menuName: "Login",
    icon: LogIn,
    highlightOn: ["login"],
  },
  {
    path: "/login",
    id: "Public",
    element: <LoginPage />,
    menuName: "Login",
    icon: LogIn,
    highlightOn: ["login"],
  },
  {
    path: "/auth/callback",
    id: "Public",
    element: <CognitoCallback />,
    menuName: "SSO Callback",
    icon: LogIn,
    highlightOn: ["auth"],
  },
  {
    path: "*",
    id: "Public",
    element: (
      <>
        {/* auto-redirect to login page */}
        <Navigate to="/login" replace />
      </>
    ),
    menuName: "Login",
    icon: LogIn,
    highlightOn: ["login"],
  },
];

export default guestRoutes;
